const $ = require("../../node_modules/jquery/dist/jquery.min")

module.exports = {
  init: () => {
    const trigger = $(".dropdown-list-item-trigger")
    const expander = $(".dropdown-list-item--expands")

    trigger.on("click", function() {
      const element = $(this).closest(expander)
      $(".dropdown-list-item--expanded")
        .not(element)
        .removeClass("dropdown-list-item--expanded")
      element.toggleClass("dropdown-list-item--expanded")
    })
  },
}
